var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37796 3.49653L3.35473 4.09011C2.53124 4.56781 2.11949 4.80667 1.89311 5.20403C1.66675 5.60138 1.66675 6.08528 1.66675 7.05307V13.8569C1.66675 15.1285 1.66675 15.7643 1.95196 16.1182C2.14176 16.3537 2.40771 16.5119 2.70175 16.5644C3.14363 16.6433 3.68465 16.3294 4.76664 15.7018C5.50138 15.2755 6.20851 14.8328 7.08747 14.9529C7.4873 15.0075 7.86867 15.1972 8.63141 15.5764L11.8097 17.1567C12.4971 17.4985 12.5034 17.5 13.2679 17.5H15.0001C16.5714 17.5 17.3571 17.5 17.8452 17.0011C18.3334 16.5022 18.3334 15.6991 18.3334 14.0931V8.47625C18.3334 6.87019 18.3334 6.06717 17.8452 5.56823C17.3571 5.0693 16.5714 5.0693 15.0001 5.0693H13.2679C12.5034 5.0693 12.4971 5.06783 11.8097 4.726L9.03333 3.34553C7.87411 2.76914 7.29451 2.48095 6.67706 2.50098C6.05961 2.52101 5.49906 2.84618 4.37796 3.49653Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 2.5V14.5833",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.41699V17.0837",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location-outline.af9ae8f64211ca965432280952892d33.svg";
export { ForwardRef as ReactComponent };